import Link from "next/link";
import { FC, useRef, useState } from "react";
import styles from "./styles.module.scss";

import Button from "@generic-components/Button";
import { useTranslation } from "@app/useTranslation";
import { usePathname } from "next/navigation";
import { useDispatch, useSelector } from "react-redux";
import {
  getIsLoggedIn,
  getProfilePicture,
  getRole,
  getUserDetail,
  removeUserDetails,
  setLoggedIn,
  setProfilePicture,
} from "@app/lib/features/login/loginSlice";

import { useRouter } from "next/navigation";
import { deleteCookie } from "@app/utils/cookie";
import { hideLoader, showLoader } from "@app/lib/features/loader/loaderSlice";
import store, { resetStore } from "@app/lib/store";
import { COOKIE_NAME } from "@app/components/config";
import dummyImage from "public/background/profile.png";
import { pushGaEvents } from "@app/utils/common";

interface SidenavProps {
  isOpen: boolean;
  isLoginOpen: (a?: any) => void;
  toggleSidenav: () => void;
}

const Sidenav: FC<SidenavProps> = ({ isOpen, toggleSidenav, isLoginOpen }) => {
  const isLoggedIn = useSelector(getIsLoggedIn);
  const userData = useSelector(getUserDetail);
  const userRole = useSelector(getRole);
  const dispatch = useDispatch();
  const router = useRouter();
  const bgContainerRef = useRef(null);
  const { t } = useTranslation();
  const profilePicture = useSelector(getProfilePicture);
  const pathname = usePathname();
  const logout = () => {
    try {
      dispatch(resetStore());
      router.push("/home");
      dispatch(setLoggedIn(false));
      dispatch(setProfilePicture(""));
      dispatch(removeUserDetails());
      sessionStorage.clear();
      localStorage.clear();
      deleteCookie(COOKIE_NAME.refreshToken);
      deleteCookie(COOKIE_NAME.token);
      deleteCookie(COOKIE_NAME.role);
      deleteCookie(COOKIE_NAME.isLoggedIn);
      deleteCookie(COOKIE_NAME.userDetails);
      if (pathname.toLowerCase() === "/home") {
        setTimeout(() => {
          dispatch(hideLoader());
        }, 500);
      }
    } catch (err) {
      console.error("error in logout", err);
    }
  };
  const Loader = () => {
    store.dispatch(showLoader());
  };
  return (
    <div
      ref={bgContainerRef}
      className={`fixed inset-0 ${
        styles.zIndex
      } bg-gray-800 bg-opacity-75 transition-opacity ${
        isOpen ? "opacity-100" : "opacity-0 pointer-events-none test"
      }`}
      onClick={() => {
        if (isOpen) toggleSidenav();
      }}
    >
      <div
        className={`fixed top-0 left-0 w-64 h-full transform transition-transform ${
          isOpen ? "translate-x-0" : "-translate-x-full"
        } ${styles.sideNav}`}
      >
        <button
          onClick={toggleSidenav}
          style={{ top: "1.3rem", color: "#00333e" }}
          className="absolute right-2 w-6 h-6 items-center text-xl justify-center rounded-full to-white text-white"
        >
          &times;
          {/* <StyledIcon icon="arrowLeft" width={10} inline={false} /> */}
        </button>
        <div className="items-left justify-left mt-1">
          <div className="rounded-lg px-5">
            {isLoggedIn ? (
              <div>
                <div className="pt-3"></div>
                <span
                  className={`pl-2 dnt gap-2 ${styles.profileSection} cursor-pointer`}
                  onClick={() => {
                    isLoggedIn ? router.push("/profile") : isLoginOpen();
                  }}
                >
                  <img
                    src={profilePicture ? profilePicture : dummyImage.src}
                    alt="Profile Icon"
                    className={`${styles.profileIcon} dnt`}
                  />
                  <div className="font-semibold dnt text-center">
                    {" Hi " + userData?.userDetails.fullName?.split(" ")?.[0]}
                  </div>
                </span>
              </div>
            ) : (
              <Button
                id={"loginOrSignup"}
                name={"loginOrSignup"}
                onClick={() => {
                  pushGaEvents({
                    event: "sign_in",
                    section: "sell",
                    user_id: userData?.userDetails?.userId,
                  });
                  isLoggedIn ? router.push("/profile") : isLoginOpen();
                }}
                btnText={"Login"}
                className={`${styles.buttonStyle} genericButtonColor`}
              />
            )}
          </div>
        </div>
        <nav className="mt-4">
          <ul className="text-black" onClick={toggleSidenav}>
            {!isLoggedIn && (
              <li className="py-2 px-6 hover:bg-gray-200">
                <Link
                  href="#"
                  onClick={() => {
                    pushGaEvents({
                      event: "sign_up",
                      section: "sell",
                      user_id: userData?.userDetails?.userId,
                    });
                    isLoggedIn ? router.push("/profile") : isLoginOpen(true);
                  }}
                >
                  Sign Up
                </Link>
              </li>
            )}
            <li className="py-2 px-6 hover:bg-gray-200">
              <Link href="/home">Home</Link>
            </li>
            {
              // ((userRole === "seller" && isLoggedIn) || !isLoggedIn) &&
              <li className="py-2 px-6 hover:bg-gray-200">
                <Link href="/sell" className="grid w-full">
                  Sell
                </Link>
              </li>
            }
            <li className="py-2 px-6 hover:bg-gray-200">
              <Link href="/buy" className="grid w-full">
                Buy
              </Link>
            </li>
            {/* <li className="py-2 px-6 hover:bg-gray-200">
              <Link href="/browse">Browse</Link>
            </li> */}
            {/* <li className="py-2 px-6 hover:bg-gray-200">
              <Link href="#" className="grid w-full">
                About us
              </Link>
            </li> */}
            {/* {userRole === "seller" && isLoggedIn && (
              <li className="py-2 px-6 hover:bg-gray-200">
                <Link href="/sell/my-properties" className="grid w-full">
                  {t("dashboardSideNav.dashboard")}
                </Link>
              </li> 
            )} */}
            {userRole === "seller" && isLoggedIn && (
              <li
                className="py-2 px-6 hover:bg-gray-200"
                onClick={() =>
                  pathname === "/sell/my-properties" ? "" : Loader
                }
              >
                <Link href="/sell/my-properties">
                  {t("dashboardSideNav.myProperties")}
                </Link>
              </li>
            )}
            {isLoggedIn && (
              <li className="py-2 px-6 hover:bg-gray-200">
                <Link href="/my-messages">
                  {t("dashboardSideNav.myMessages")}
                </Link>
              </li>
            )}
            {isLoggedIn && (
              <li
                className="py-2 px-6 hover:bg-gray-200"
                onClick={() => (pathname === "/my-favourites" ? "" : Loader)}
              >
                <Link href="/my-favourites">
                  {t("dashboardSideNav.myFavourites")}
                </Link>
              </li>
            )}
            <li className="py-2 px-6 hover:bg-gray-200">
              <Link href="/contact-us" className="grid w-full">
                {t("dashboardSideNav.contactUs")}
              </Link>
            </li>
            {isLoggedIn && (
              <li className="py-2 px-6 hover:bg-gray-200">
                <span onClick={logout} className="grid w-full">
                  <span className={styles.sideText}>
                    {t("dashboardSideNav.logOut")}
                  </span>
                </span>
              </li>
            )}
          </ul>
        </nav>
      </div>
    </div>
  );
};

export default Sidenav;
